module.exports = __webpack_public_path__ + "img/step10-c.885a82a3.png";